module.exports = __webpack_public_path__ + "static/media/haaga-helia-logo.18820c80.jpg";